export class AffordabilityParametersModel {
    id: any;
    description: string;
    code: string;
    value: number;
    isEditable :boolean = false;
}
